import { ControllerProps } from "csi/middleware/common";
import { ReactionStore } from "csi/utility/mobxUtility";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { RestoreFromBOMStore, RestoreFromBOMStoreContext } from "./RestoreFromBOMStore";
import { SaveDialog } from "designSystem/index";
import { RestoreSettingsForm } from "../RestoreSettingsForm";

export interface RestoreFromBOMDialogProps<T extends ReactionStore> extends ControllerProps {
	store: T;
}
export const RestoreFromBOMDialog: FunctionComponent<RestoreFromBOMDialogProps<RestoreFromBOMStore>> = observer((props) => {
	const {
		store, onClose,
	} = props;
	const { actionMessage, titleRes, save } = store || {};


	return ( 
		<>
			{store && (
				<RestoreFromBOMStoreContext.Provider value={store}>
					<SaveDialog
						actionMessage={actionMessage}
						onClose={onClose}
						onSave={save}
						open
						titleRes={titleRes}
						width={528}
					>
						{{
							main: (
								<RestoreSettingsForm />
							),
						}}
					</SaveDialog>
				</RestoreFromBOMStoreContext.Provider>
			)}
		</>
	);
});

export default RestoreFromBOMDialog;